export enum Environment {
  Local = 'LOCAL',
  Qa = 'QA',
  Production = 'PRODUCTION',
  Unknown = 'UNKNOWN',
}
